module.exports = __webpack_public_path__ + "static/media/pli-tag.2427119f.svg";